import React from "react";
export const erase = (stroke) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 3.068 6.35"
    >
        <g id="layer1" transform="translate(-1.642 0)">
            <g id="g844" transform="translate(0.175 -0.002)">
                <path
                    id="path2864"
                    d="M1.568,1.869c0,.374,2.065.68,2.9.1l.012.613c-.179.671-2.6.8-2.915-.042ZM4.457.327c.018.15-.614.274-1.413.279S1.576.492,1.549.343s.6-.276,1.4-.282,1.475.11,1.512.26m0,.028C4.393.488,3.829.6,3.119.61A3.271,3.271,0,0,1,1.541.378V1.855h0c-.028.029-.015.059,0,.089.072.17.693.359,1.5.344s1.491-.228,1.421-.4h0c0-.011.012-.022,0-.033h0Zm-.01,2.423a6.234,6.234,0,0,1-.857.354L3.582,6.231l.866-.669ZM2.5,3.149l1,0L3.472,6.278l-.98.005ZM1.56,2.542c.058.154.121.309.844.6L2.395,6.23,1.56,5.574Z"
                    fill="none"
                    stroke={stroke}
                    strokeWidth="0.118"
                    opacity="0.997"
                />
            </g>
        </g>
    </svg>
);
